// 📊 장표 컴포넌트 레지스트리 — Overlay169 가 `segment.slide.type` 으로 동적 조회하는 정본.
//   = MSB 디렉터 어휘 9종(LAYOUT_COMPONENTS · EF 카탈로그와 1:1 동기 — tests/msb-catalog-sync)
//   + 클라이언트 전용 확장(kineticTypo — 디렉터가 고르지 않고 브릿지·직접편집만 만든다).
//   ★LAYOUT_COMPONENTS 에 직접 얹지 않는 이유★: 그 맵은 msb-director 가 고를 수 있는 어휘와 같아야
//   한다(카탈로그 동기 테스트). 확장 타입은 EF 무개조로 이 층에서만 산다.
//   🏗 [건설] 사고 사례 브리핑 3종(incidentBrief·preventionCard·tbmCard)도 같은 길 — 설계도 브릿지가 브리핑 사실로 끼운다.
import type React from 'react';
import { LAYOUT_COMPONENTS } from './layouts';
import { KineticTypo } from './kinetic-typo';
import { CONSTRUCTION_SLIDE_COMPONENTS } from './construction-slides';
import { MORNING_SLIDE_COMPONENTS } from './morning-layouts';

export const SLIDE_COMPONENTS = {
  ...LAYOUT_COMPONENTS,
  kineticTypo: KineticTypo,
  ...CONSTRUCTION_SLIDE_COMPONENTS,
} as const;

export type SlideComponentId = keyof typeof SLIDE_COMPONENTS;

/** 🏗🌅 «아침 안전 조회» 틀 전용 장표(화면 전용 · 틀 조립기만 만든다). ★SLIDE_COMPONENTS 에 섞지 않는다★ —
 *  그 맵은 정밀 편집 원천 종류(SOURCE_SLIDE_IDS)와 1:1 계약이라, 여기 종류는 정밀 편집에서 «미지 장표»로 비활성 보존된다. */
export const EXTRA_SLIDE_COMPONENTS: Record<string, React.ComponentType<Record<string, unknown>>> =
  MORNING_SLIDE_COMPONENTS as unknown as Record<string, React.ComponentType<Record<string, unknown>>>;

/** 장표 종류 → 그릴 컴포넌트(공용 → 틀 전용 순). 없으면 undefined(그리지 않음 · 종전 가드). */
export function slideComponentOf(type: string | undefined | null): React.ComponentType<Record<string, unknown>> | undefined {
  if (typeof type !== "string") return undefined;
  return (SLIDE_COMPONENTS as unknown as Record<string, React.ComponentType<Record<string, unknown>> | undefined>)[type] ?? EXTRA_SLIDE_COMPONENTS[type];
}
